import LottieFromUrl from "../../../../components/LottieFromUrl/LottieFromUrl";
import { TaskData } from "../../types";
import "./TaskTile.scss";

interface TaskTileProps {
  item: TaskData;
  taskData: TaskData[];
  setTaskData: (next: TaskData[]) => void;
}

function TaskTile({ item, taskData, setTaskData }: TaskTileProps) {
  const handlePress = () => {
    const updated = taskData.map((t) =>
      t.id === item.id ? { ...t, isSelected: !item.isSelected } : t,
    );
    setTaskData(updated);
  };

  return (
    <button
      type="button"
      onClick={handlePress}
      className={`task-tile${item.isSelected ? " task-tile--selected" : ""}`}
    >
      <LottieFromUrl url={item.iconUrl} className="task-tile__icon" />
      <span className="task-tile__title">{item.title}</span>
    </button>
  );
}

export default TaskTile;
